import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2392">
      <Navbar data-id="element-2393" />
      <main data-id="element-2394">
        <ConsularAffairs data-id="element-2395" />
      </main>
      <Footer data-id="element-2396" />
      <FeedbackPopup data-id="element-2397" />
    </div>;
}